cv.ResetPasswordView = Marionette.LayoutView.extend({
  template: cv.Templates['auth/reset_password'],

  events : {
    'click .button' : 'submit'
  },

  behaviors: [{
    behaviorClass: cv.FormBehavior,
    suppress_notifications : true
  }],

  validation: {
    password: [{
        required: 'true',
        msg: "Required"
    },{
			minLength : 6,
			msg : "Password must be at least 6 characters"
		}],
    confirm_password: [{
      required: 'true',
      msg: 'Required'
    },{
      equalTo: 'password',
      msg: 'Password must match'
    }]
  },

  initialize: function(options){
    this.listenTo(this, 'form:saved', function(){
      vent.trigger('notif:success', 'Resetting password...');

      $.ajax({
        url: cv.api_path + '/auth/reset_password',
        dataType: "json",
        data: {
          user_id : this.model.get('user_id'),
          pass_key : this.model.get('pass_key'),
          password : this.model.get('password'),
          confirm_password : this.model.get('confirm_password'),
          campaign_id : cv.campaign.get('id')
        },
        type: "post",
        success: _.bind(function(data){
          vent.trigger('notif:clear');

          this.$('.section').html(cv.Templates['auth/reset_password_success']());
        }, this),
        error: _.bind(function(data){
          vent.trigger('notif:error', 'There was an error resetting your password.');
        }, this)
      });
    }, this);

    this.listenTo(this, 'form:changed', function(model){
    }, this);

    this.listenTo(this, 'form:has_errors', function(){
      vent.trigger('notif:error', 'Please fix the errors on this form.');
    }, this);

    this.model.set('user_id', options.user_id);
    this.model.set('pass_key', options.pass_key);

    console.log('ResetPasswordView initialized');
  },

  submit: function(e){
    e.preventDefault();
    e.stopPropagation();

    this.trigger('form:save');
  },

  onShow: function(){
    // Change document title
    document.title = 'Reset Password';
  }
});
